import React from 'react';
import './Compass.css';
import './Element.css';
import compassImage from '../../images/kompas_med_rettede_bogstaver.png';


import PropTypes from 'prop-types';


const Compass = ({ compassPlacement = {}, degreesToRotate = 0 }) => {
    const mergedPlacement = {
        left: '83.2vw',
        top: '5vh',
        height: 15,
        ...compassPlacement
    };
    const heightToWidthRatio = 9 / 16;
    const width = mergedPlacement.height * heightToWidthRatio;
    const compassStyling = {
        left: mergedPlacement.left,
        top: mergedPlacement.top,
        width: width + 'vw',
        height: mergedPlacement.height + 'vh',
        transform: `rotate(${degreesToRotate}deg)`
    };
    return (
        <div id="compass" className="compass-wrapper" style={compassStyling}>
            <img src={compassImage} className="compass-image" alt="Compass" />
        </div>
    );
}


Compass.propTypes = {
    compassPlacement: PropTypes.shape({
        left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        height: PropTypes.number
    }),
    degreesToRotate: PropTypes.number
};

export default Compass;